export default "__VITE_ASSET__B06eqejg__"